// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.factCss_f1h8love{margin-top:4px;}
.datePlaceCss_d3t2be3{display:flex;}
`, "",{"version":3,"sources":["webpack://./node_modules/@fs/zion-ui/dist/es/fact-block/FactBlock.css"],"names":[],"mappings":"AAAA,kBAAkB,cAAc,CAAC;AACjC,sBAAmF,YAAY,CAAC","sourcesContent":[".factCss_f1h8love{margin-top:4px;}\n.datePlaceCss_d3t2be3{display:-webkit-box;display:-webkit-flex;display:-ms-flexbox;display:flex;}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
